import clsx from 'clsx';
import { AriaAttributes, createElement } from 'react';

import { IconList, Icons } from './Icons';

export type IconProps = {
  /** Indicates whether the element is exposed to an accessibility API. */
  ariaHidden?: AriaAttributes['aria-hidden'];
  /** name of the icon to use */
  name: IconList;
  /** size of the icon, defaults to 'medium' */
  size?: 'small' | 'medium' | 'large' | 'xlarge';
  /** id of the title element in the rendered svg */
  titleId?: string;
  /** color of the icon */
  color?: 'black' | 'white' | 'red' | 'gray';
};

const colorVariants: Record<NonNullable<IconProps['color']>, `text-${NonNullable<IconProps['color']>}`> = {
  black: 'text-black',
  white: 'text-white',
  red: 'text-red',
  gray: 'text-gray',
};

const sizeToSvgClassName: Record<NonNullable<IconProps['size']>, string> = {
  small: 'text-16',
  medium: 'text-24',
  large: 'text-[32px]',
  xlarge: 'text-[40px]',
};

export const Icon = ({ ariaHidden = false, name, color = 'black', size = 'medium', titleId }: IconProps) =>
  Icons[name]
    ? createElement(Icons[name], {
        ['aria-hidden']: ariaHidden,
        preserveAspectRatio: 'xMidYMid meet',
        className: clsx(colorVariants[color], sizeToSvgClassName[size]),
        titleId,
      })
    : null;
